// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"523":"773a7003","904":"820f725e"}[chunkId] + ".chunk.css");